import { fileDownload } from 'utils/fileDownload';
import { logError } from 'utils/sentryUtils';

import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const trainingApi = {
    getAllTrainingScenarios: async (facilityID) => {
        const url = `api/warehouse/v1/training?facilityID=${facilityID}`;
        return mmFetchWithResponse(url);
    },
    getTrainingLPN: async (id) => {
        const url = `api/warehouse/v1/training/lpn/${id}`;
        try {
            const response = await mmFetch(url);
            if (response.ok === true) {
                await fileDownload(response, `training-${id}.pdf`);
            }
            return response.ok;
        } catch (e) {
            logError(e);
            return false;
        }
    },
};

export { trainingApi };
